module.exports = __webpack_public_path__ + "img/huge-icon-user.ab4ef08f.svg";